import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

// Example of creating an axios instance
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL, // Set your API base URL
});

// const navigate = useNavigate();

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Clear user session
            localStorage.removeItem('user'); // Clear stored token or session data

            // Show toaster notification
            toast.error('Your session has expired. Please log in again.');
            window.location.href = '/'

            // Redirect to login page
            // navigate('/signin');
        }
        return Promise.reject(error);
    }
);

export default api;
